import React, { PropTypes } from 'react';
import ComponentRegistry from "../../Common/ComponentRegistry";
import $ from "jquery";

export default class ProductController extends React.Component {
    constructor(props) {
        super(props);

        this.state = {isCompared: false, products: []};
        this.store = ComponentRegistry.getStore("ProductCompareStore");
        this.store.listen(({ products }) => this.setState({
            products,
            isCompared: products.filter(product => this.props.product.id === product.id).length > 0
        }));
    }

    addProduct()
    {
        if (this.state.products.length < this.props.maxItems) {
            this.setState({message: null});
            $.ajax({
                url: this.props.url,
                data: {products: this.state.products.map(value => value.slug)},
                async: false,
                method: 'POST',
                dataType: "json",
                success: ({matrix, message}) => {
                    if (matrix) {
                        this.store.add(this.props.product, matrix);
                    } else {
                        this.store.error(message);
                        this.setState({error: message})
                    }
                }
            });
        } else {
            this.store.error(this.props.labels.max_compare_reached);
            this.setState({error: this.props.labels.max_compare_reached})
        }
    }

    render() {
        const ProductView = ComponentRegistry.get("ProductCompareViewsProductView");

        return (
            <ProductView {...this.props} {...this.state} onChange={() => {
                this.state.isCompared ? this.store.remove(this.props.product) : this.addProduct();
            }} />
        );
    }
}

ProductController.defaultProps = {
    maxItems: 3
};

ProductController.propTypes = {
    product: PropTypes.shape({
        id: PropTypes.string.isRequired
    }).isRequired,
    labels: PropTypes.shape({
        max_compare_reached: PropTypes.string.isRequired
    }).isRequired,
    maxItems: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductCompare/Controllers/ProductController.jsx